import React, { useState } from 'react';
import { Tooltip, IconButton, Snackbar, Alert } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { createPortal } from 'react-dom';

interface LinkClipBoardProps {
  link: string;
  title?: string
}

export const LinkClipBoard: React.FC<LinkClipBoardProps> = ({ link, title = 'Copiar Link' }) => {
  const [open, setOpen] = useState(false);

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(link);
    setOpen(true);
  };

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <Tooltip title={title} arrow>
        <IconButton 
          onClick={handleCopyToClipboard}
          size="small"
          color="primary"
        >
          <ContentCopyIcon />
        </IconButton>
      </Tooltip>
      {createPortal(
        <Snackbar 
          open={open} 
          autoHideDuration={3000} 
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
            Link copiado com sucesso!
          </Alert>
        </Snackbar>,
        document.body
      )}
    </>
  );
};

export default LinkClipBoard;
